/**
 * Device type helper functions
 * Centralized logic for identifying device types by profile ID or name
 */

import { Device } from '../types';
import { DEVICE_PROFILE_IDS } from '../types';

export function isNH3Sensor(device: Device): boolean {
  return device.deviceProfileId === DEVICE_PROFILE_IDS.NH3_SENSOR;
}

export function isBarnThermometer(device: Device): boolean {
  return device.deviceProfileId === DEVICE_PROFILE_IDS.BARN_THERMOMETER;
}

export function isModberryDevice(device: Device): boolean {
  // Modberry devices are gateways - check profile ID first, fallback to name/modelType
  // Note: Some legacy devices may not have deviceProfileId synced
  if (device.deviceProfileId === DEVICE_PROFILE_IDS.MODBERRY) {
    return true;
  }
  // Fallback for devices without synced profile ID
  return !!(device.name?.includes('Modberry') || device.modelType?.includes('Modberry'));
}

export function isCellarDepthLaser(device: Device): boolean {
  return device.deviceProfileId === DEVICE_PROFILE_IDS.CELLAR_LASER;
}

/**
 * Check if device should be included in correlation
 * Returns true for Modberry, NH3 sensors, barn thermometers, cellar depth lasers
 * Returns false for ancillary devices (pumps, valves, door sensors, etc.)
 */
export function shouldCorrelateDevice(device: Device): boolean {
  return (
    isNH3Sensor(device) ||
    isBarnThermometer(device) ||
    isModberryDevice(device) ||
    isCellarDepthLaser(device)
  );
}
